import i18n from "i18next";

export const formatCurrency = (amount: number | string, currency = "USD") => {
  // Convert string → number (safely)
  const numericAmount =
    typeof amount === "number" ? amount : parseFloat(amount);

  // If parsing fails, return raw fallback
  if (isNaN(numericAmount)) {
    return `${currency} ${amount}`;
  }

  try {
    return new Intl.NumberFormat(i18n.language, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  } catch {
    return `${currency} ${numericAmount.toFixed(2)}`;
  }
};
